import React, { useEffect } from 'react';
import { BankData } from '../../../types';
import { GroupButton } from '../../common';
import EditIcon from '../../../assets/icons/EditIcon';
import DeleteIcon from '../../../assets/icons/DeleteIcon';
import { EditBankAccount } from './edit';
import { BankAccountDeletePrompt } from './delete';
import { SidebarDrawer } from '../../common';
import LeftNotificationPopup from '../../core/NotificationPopup/LeftNotificationPopup';
import ProcessSuccessful from '../../../assets/icons/ProcessSuccessful';
import { CheckboxComponent } from '../../core/Forms';
import PageLoader from '../../common/PageLoader';
import { shortenText } from '../../../utils';

interface ViewProps {
  bankAccount: BankData
  onEdit: () => void;
  onDelete: () => void;
  onToggleActive: () => void;
  accountIndex: number;
}

export const BankAccountView: React.FC<ViewProps> = ({ bankAccount, onEdit, onDelete, onToggleActive,  accountIndex, }) => {
  const [showEditTab, setShowEditTab] = React.useState(false);
  const [showDeletePrompt, setShowDeletePrompt] = React.useState(false);
  const [showSuccessSidebar, setShowSuccessSidebar] = React.useState(false);
  const [, setAccountIndex] = React.useState<number>(0);
  const [isActive, setIsActive] = React.useState(bankAccount.isActive);
  const [bankAccountState, setBankAccountState] = React.useState<BankData>(bankAccount)
  const [isLoading, setIsLoading] = React.useState(true)

  const handleEdit = () => {
    onEdit();
    setShowEditTab(true);
    setShowDeletePrompt(false);
     
  };

  const handleDelete = () => {
    // onDelete();
    setShowDeletePrompt(true);
  };

  const handleToggleActive = () => {
    onToggleActive();
    setIsActive(!isActive);
  };

  const closeSuccessSidebar = () => {
    setShowSuccessSidebar(false);
  };
  
  
  
  useEffect(() => {
    const isLoading = Object.values(bankAccountState).some((value) => value === undefined);
   
   
  
    if (bankAccountState.bankName === "") {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
    setIsLoading(isLoading);
  }, [bankAccountState]);
 
  const handleEditSuccess = (updatedData: BankData) => {

    setBankAccountState(updatedData);
 
    setShowEditTab(false);
  };
  

  return (
    <>
  {isLoading ?  <PageLoader></PageLoader>  : 
  (
  <div className="flex flex-col lg:flex-wrap justify-center md:justify-start lg:gap-4">
  
      {!showEditTab ? (
        <>

        <div className="w-[318px] md:w-[456px] biglg:w-[400px] xl:w-[456px] 2xl:w-[500px] lg:w-[400px] h-fit mx-auto bg-[#EDF2F5] mt-[35px] lg:ml-[4em] lg:mt-[5em] rounded border lg:pr-[2em]">
          <div className="flex justify-between items-center gap-[36px] pt-[51px]">
            <div className="flex flex-col gap-[7px] lg:gap-0 pl-[20px]">
              <h3 className="text-[#000000] text-[13px] pt-[20px]  font-normal flex items-center mt-[-5em]">
                Bank Name:
              </h3>
              <span className="text-[#000000] font-semibold lg:text-[16px] text-[14px]">
              {shortenText(bankAccountState.bankName, 10)}
               
                  {shortenText(bankAccountState?.
                      //@ts-ignore 
                  data?.bankAccounts[accountIndex]?.bankName, 10)}
                </span>
            </div>
            <div className="text-[#044E97] text-[20px] md:text-[17px] lg:text-[14+px] font-medium mt-[-2rem] ">
              <GroupButton
                buttons={[
                  {
                    text: 'Edit',
                    icon: <EditIcon />,
                    onClick: handleEdit,
                  },
                  {
                    text: 'Delete',
                    icon: <DeleteIcon />,
                    onClick: handleDelete,
                  },
                ]}
              />
            </div>
          </div>
          <div className='flex justify-between px-[20px] pt-[20px] md:pt-[30px]  mb-[20px]  md:mb-[30px]'>
          <div className='flex flex-col gap-[7px]'>
            <h3 className="text-[#000000] text-[13px] font-normal flex items-center">
              Account Number:   
            </h3>
            <span className="text-[#000000] font-semibold lg:text-[16px] text-[14px]flex items-center">
                {bankAccountState.accountNumber}
            
                {bankAccountState?.
                   //@ts-ignore 
                   data?.bankAccounts[accountIndex]?.accountNumber}
              </span>
          </div>
            
          <div className='flex flex-col gap-[7px]'>
          <h3 className="text-[#000000] text-[13px] md:text-[13px] font-normal flex ">
              Account Name:
            </h3>
            <span className="text-[#000000] font-semibold md:text-[16px] lg:text-[16px] text-[14px]">
                {bankAccountState.accountName}
           
                {bankAccountState?.
                    //@ts-ignore 
                   data?.bankAccounts[accountIndex]?.accountName}
            </span>
        </div>
            
          </div>         
          
        </div>
        <div className="flex gap-[52px] mt-6 ml-[16px] justify-start md:justify-start md:ml-[7.7em] bigmd:ml-[11em] biglg:ml-[4.2em] xl:ml-[4em] lg:justify-start items-center lg:items-center sm:ml-[76px] ">
            <label htmlFor="active" className="font-semibold lg:block lg:font-sm lg:mb-3 lg:text-[13px]">
              {isActive ? 'Active Bank Account' : 'Inactive Bank Account'}
            </label>
            <CheckboxComponent
              name="active"
              label="" 
              onChange={handleToggleActive}
              checked={isActive}
            />
          </div>
        </>
        
      ) : (
        <EditBankAccount
                  bankAccount={bankAccount}
                  onEditSuccess={handleEditSuccess}
                  accountIndex={accountIndex}                       />
      )}

      {showDeletePrompt && (
        <BankAccountDeletePrompt
          showPrompt={showDeletePrompt}
          bankAccountId={accountIndex}
          onBankAccountDelete={onDelete}
        />
      )}

      {showSuccessSidebar && (
        <SidebarDrawer title="" show={true} position="left" onClose={closeSuccessSidebar}>
          <LeftNotificationPopup
            title="Bank Account Deleted"
            icon={<ProcessSuccessful />}
            position="left"
            showSuccessModal={true}
          />
        </SidebarDrawer>
      )}
    </div>)
   } 

    
    </>
    
  );
};
